function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.3334 6.66667H10C8.16169 6.66667 6.66669 8.16167 6.66669 10V18.3333H10V13.3333L20.6667 21.3333C20.9553 21.5494 21.3061 21.6663 21.6667 21.6663C22.0272 21.6663 22.3781 21.5494 22.6667 21.3333L33.3334 13.3333V28.3333H20V31.6667H33.3334C35.1717 31.6667 36.6667 30.1717 36.6667 28.3333V10C36.6667 8.16167 35.1717 6.66667 33.3334 6.66667ZM21.6667 17.9167L11.11 10H32.2234L21.6667 17.9167Z",
  fill: "#CBD5E0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.33331 20H15V23.3333H3.33331V20ZM6.66665 25H16.6666V28.3333H6.66665V25ZM11.6666 30H18.3333V33.3333H11.6666V30Z",
  fill: "#CBD5E0"
});

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.e9bc51c3.svg";
export { ForwardRef as ReactComponent };